var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 895"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M554 674c-72 28-167 27-231-7-41-23-77-64-77-110 1-37 47-53 73-32 19 19 21 41 40 65 40 57 184 43 187-33 1-33-27-51-55-60-88-26-233-32-235-153 1-98 102-129 189-129 62 0 137 17 170 75s-21 101-62 73c-23-21-24-46-53-67-37-26-145-21-150 40 0 57 111 59 187 85 163 46 129 214 17 253zm278-166A397 397 0 00377 56C171-113-111 137 47 364a398 398 0 00473 474c226 182 512-116 312-330z"
  })));
}
export default SvgSkype;